<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Transferências registradas</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3 style="justify-content: flex-end;">
          <v-flex xs12 md3 lg3 px-1>
            <DefaultFilterDate ref="filterStartDate" @reload="this.reloadStartDate" kind="date" label="Data inicial" />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <DefaultFilterDate ref="filterEndDate" @reload="this.reloadEndDate" kind="date" label="Data final" />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <CompanySelect ref="filterCompanyId" :model="filterCompanyId" label="Parceiro" @onCompanyList="this.companyListSelected" @onIdSelected="this.companyIdSelected" />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <CompanySelect ref="filterSubjectId" :model="filterSubjectId" :label="i18n('Nº do Doc. Cliente')" search_mode="document_number_prefix" @onCompanyList="this.subjectListSelected" @onIdSelected="this.subjectIdSelected" />
          </v-flex>
          <v-flex xs12 md3 lg3 px-1>
            <v-text-field
              v-model="filterId"
              box
              append-icon="manage_search"
              class="search-filter"
              placeholder="Pesquisar por ID"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2 lg2 px-1>
            <v-select
              box
              label="Tipo da transação"
              v-model="filterTransactionType"
              clearable
              @click:clear="filterTransactionType = null"
              :items="filterTransactionTypeItems"
            ></v-select>
          </v-flex>
          <v-flex xs12 md2 lg2 px-1>
            <v-select
              box
              label="Moeda"
              v-model="filterCurrency"
              clearable
              @click:clear="filterCurrency = null"
              :items="filterCurrencyItems"
            ></v-select>
          </v-flex>
          <v-flex xs12 md2 lg2 px-1>
            <v-switch
              v-model="pendingFilter"
              label="Somente pendentes"
            ></v-switch>
          </v-flex>
          <v-flex xs12 md3 lg3 class="align-contents-right">
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
              Update
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <div v-if="wiresLoaded == 'not_loaded'">Carregando transferências...</div>
          <div v-if="wiresLoaded == 'error'">Algo errado. Não foi possível carregar as transferências.</div>
          <div v-if="wiresLoaded == 'not_authorized'">Não foi possível carregar as transferências. Você não foi autorizado.</div>
          <div v-if="wiresLoaded == 'empty'">Não existem transferências neste momento.</div>
          <transition name="fade">
            <wire-list class="mt-3" :config="wireConfig" v-if="wiresLoaded == 'ok'" @loadMoreRecords="loadWires" @disableCompanyWireActions="disableCompanyWireActions"/>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import WireList from "./WireList"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"
import CompanySelect from "./components/filters/CompanySelect"
import utils from "./shared/Utils"
import { getAllCurrenciesSelect } from "./shared/Currencies";

export default {
  name: 'AdminWireList',
  components: { layout: LeftBarLayout, 'wire-list': WireList, DefaultFilterDate, CompanySelect },
  data() {
    return {
      wireConfig: {
        title: 'Transferências recentes',
        records: [],
        loading: false,
        perPage: 100
      },
      wiresLoaded: 'not_loaded',
      pendingFilter: false,
      filterId: null,
      filterStartDate: null,
      filterEndDate: null,
      filterCompanyId: null,
      filterCompanyList: [],
      filterSubjectId: null,
      filterSubjectList: [],
      filterTransactionType: null,
      filterCurrency: null,
      consolidateFilter: {
        filterId: null,
        pendingFilter: false,
        filterStartDate: null,
        filterEndDate: null,
        filterCompanyId: null,
        filterCompanyList: [],
        filterSubjectId: null,
        filterSubjectList: [],
        filterTransactionType: null,
        filterCurrency: null
      },
      filterTransactionTypeItems: [
          {value: "automatic", text: "Automática"},
          {value: "manual", text: "Manual"}
      ],
      filterCurrencyItems: getAllCurrenciesSelect()
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadWires(null)
  },
  methods: {
    reloadStartDate(filter_date) {
      this.filterStartDate = filter_date
    },
    reloadEndDate(filter_date) {
      this.filterEndDate = filter_date
    },
    companyIdSelected(id) {
      this.filterCompanyId = id
    },
    subjectIdSelected(id) {
      this.filterSubjectId = id
    },
    companyListSelected(companyList) {
      this.filterCompanyList = companyList
    },
    subjectListSelected(subjectList) {
      this.filterSubjectList = subjectList
    },
    filter() {
      this.consolidateFilter = {
        filterId: this.filterId,
        pendingFilter: this.pendingFilter,
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate,
        filterCompanyId: this.filterCompanyId,
        filterCompanyList: [...this.filterCompanyList],
        filterSubjectId: this.filterSubjectId,
        filterSubjectList: [...this.filterSubjectList],
        filterTransactionType: this.filterTransactionType,
        filterCurrency: this.filterCurrency
      };

      this.reloadRecords()
    },
    reloadRecords() {
      if(this.wireConfig.loading) {
        this.wireConfig.loading = true
      } else {
        this.wireConfig.loading = false
        this.wireConfig.records = []
        this.wiresLoaded = 'not_loaded'
        this.loadWires(null)
      }
    },
    resetFilter() {
      this.pendingFilter = false

      this.wireConfig.records = []
      this.wiresLoaded = 'not_loaded'

      this.filterId = null

      this.filterStartDate = null
      this.$refs.filterStartDate.filterDate = null

      this.filterEndDate = null
      this.$refs.filterEndDate.filterDate = null

      this.filterCompanyId = null
      this.$refs.filterCompanyId.search = null
      this.$refs.filterCompanyId.selectedCompanyId = null
      this.$refs.filterCompanyId.entries = []

      this.filterSubjectId = null
      this.$refs.filterSubjectId.search = null
      this.$refs.filterSubjectId.selectedCompanyId = null
      this.$refs.filterSubjectId.entries = []

      this.filterTransactionType = null

      this.filterCurrency = null

      this.consolidateFilter = {
        filterId: null,
        pendingFilter: false,
        filterStartDate: null,
        filterEndDate: null,
        filterCompanyId: null,
        filterCompanyList: [],
        filterSubjectId: null,
        filterSubjectList: [],
        filterTransactionType: null,
        filterCurrency: null
      }

      this.filterCompanyList = []
      this.filterSubjectList = []

      this.reloadRecords()
    },
    resetToConsolidateFilter() {
      this.filterId = this.consolidateFilter.filterId

      this.filterStartDate = this.consolidateFilter.filterStartDate;
      this.$refs.filterStartDate.filterDate = this.consolidateFilter.filterStartDate;

      this.filterEndDate = this.consolidateFilter.filterEndDate;
      this.$refs.filterEndDate.filterDate = this.consolidateFilter.filterEndDate;

      this.filterCompanyId = this.consolidateFilter.filterCompanyId
      this.filterCompanyList = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.entries = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.search = ''
      this.$refs.filterCompanyId.selectedCompanyId = this.consolidateFilter.filterCompanyId

      this.filterSubjectId = this.consolidateFilter.filterSubjectId;
      this.filterSubjectList = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.entries = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.search = ''
      this.$refs.filterSubjectId.selectedCompanyId = this.consolidateFilter.filterSubjectId

      this.filterTransactionType = this.consolidateFilter.filterTransactionType
      this.filterCurrency = this.consolidateFilter.filterCurrency
      this.pendingFilter = this.consolidateFilter.pendingFilter
    },
    disableCompanyWireActions(wire) {
      this.$root.$emit('company-wire-actions-' + wire.id)
    },
    loadWires(last_id) {
      this.resetToConsolidateFilter()

      let successCallback = (response) => {
        if (response.body.data) {
          this.wireConfig.records = this.wireConfig.records.concat(...response.body.data)
          if (this.wireConfig.records.length === 0) {
            this.wiresLoaded = 'empty'
          } else {
            this.wiresLoaded = 'ok'
          }
        } else {
          this.wiresLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }

        this.wireConfig.loading = false
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.wiresLoaded = 'not_authorized'
        } else {
          this.wiresLoaded = 'error'
        }

        this.wireConfig.loading = false
        console.log('errorCallback', response)
        debugger
      }

      let token = this.$cookies.get('api_token')

      this.wireConfig.loading = true
      let params = { per_page: this.wireConfig.perPage }
      if (this.consolidateFilter.filterStartDate) { params.from = utils.filterDateFrom(this.consolidateFilter.filterStartDate, false).toISOString() }
      if (this.consolidateFilter.filterEndDate) { params.to = utils.filterDateTo(this.consolidateFilter.filterEndDate, false).toISOString() }

      const addFilterToParams = function(value, field, params) {
        value = typeof value === 'string' ? value.trim() : value

        if (value === null || value === '' || typeof(value) === 'undefined') { return params }
        params[field] = value
        return params
      }

      const filters = [
        { value: last_id, field: 'last_id' },
        { value: this.consolidateFilter.filterId, field: 'id' },
        { value: this.consolidateFilter.filterCompanyId, field: 'company_id' },
        { value: this.consolidateFilter.filterSubjectId, field: 'subject_id' },
        { value: this.consolidateFilter.filterTransactionType, field: 'transaction_type' },
        { value: this.consolidateFilter.filterCurrency, field: 'currency' }
      ]

      filters.forEach(filter => {
        params = addFilterToParams(filter.value, filter.field, params)
      })

    if (this.pendingFilter) params.pending = this.pendingFilter
      this.$http.get(this.$root.urls.admin__company_wires, { params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    i18n(str) {
      return this.$root.l(str)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AdminWireList.vue